import type { Region } from '~~/core/entities/Region';

const modules = import.meta.glob<Region>('~~/data/regions/*.ts');

export const regions: Record<string, Region> = {};

for (const path in modules) {
	const regionName = path.match(/\/([^\/]+)\.ts$/)?.[1];
	if (regionName) {
		modules[path]?.().then((module: any) => {
			regions[regionName] = module.default;
		});
	}
}
